import { render, staticRenderFns } from "./IndexFloor.vue?vue&type=template&id=a1d80128&scoped=true&"
import script from "./IndexFloor.vue?vue&type=script&lang=js&"
export * from "./IndexFloor.vue?vue&type=script&lang=js&"
import style0 from "./IndexFloor.vue?vue&type=style&index=0&id=a1d80128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d80128",
  null
  
)

export default component.exports